import axios from 'axios'
import { ActionTree } from 'vuex'
import { RootState, ApiVersion, Result } from '../types'
import { RegistrationMutations } from './mutations'
import { MenuType, RegistrationState, UserRegistrationRequest } from './types'
import { Response } from '@/store/response'

export const actions: ActionTree<RegistrationState, RootState> = {
  //Send registration request
  async sendRegistrationRequest({ commit }, payload: UserRegistrationRequest) {
    commit(RegistrationMutations.SET_LOADER, true)
    try {
      const { data } = await axios.post(`${ApiVersion.V1}/Doctors`, payload)
      const response: Response<String> = data
      commit(
        RegistrationMutations.SET_REGISTRATION_RESULT,
        response.succeeded ? Result.SUCCESS : Result.ERROR
      )
      commit(RegistrationMutations.SET_REGISTRATION_DOCTOR_FOLIO, response.data)
    } catch (error) {
      commit(RegistrationMutations.SET_REGISTRATION_RESULT, Result.ERROR)
      console.error(error)
    } finally {
      commit(RegistrationMutations.SET_LOADER, false)
    }
  },

  async getMenuOptions({ commit }) {
    try {
      const { data } = await axios.get(
        `${ApiVersion.V1}/AppConfigs/menuoptions`
      )
      commit(RegistrationMutations.SET_MENU_OPTIONS_LIST, data.data)
    } catch (error) {
      console.error(error)
    }
  },

  async getMenuOptionsValue({ commit }, payload: MenuType) {
    try {
      const { data } = await axios.get(
        `${ApiVersion.V1}/AppConfigs/menuoptions/detail/${payload}`
      )
      switch (payload) {
        case MenuType.IDENTIFICATION:
          commit(RegistrationMutations.SET_IDENTIFICATION_OPTIONS, data.data)
          break
        case MenuType.SPECIALITY:
          commit(RegistrationMutations.SET_SPECIALITY_OPTIONS, data.data)
          break
        case MenuType.SUBSPECIALITY:
          commit(RegistrationMutations.SET_SUBSPECIALITY_OPTIONS, data.data)
          break
        case MenuType.CONSULTORY:
          commit(RegistrationMutations.SET_CONSULTORY_OPTIONS, data.data)
          break
        default:
          console.error('Menu option values not found')
          break
      }
    } catch (error) {
      console.error(error)
    }
  }
}
